import { render } from "./HeroComp.vue?vue&type=template&id=9d3e54f4&scoped=true"
import script from "./HeroComp.vue?vue&type=script&lang=js"
export * from "./HeroComp.vue?vue&type=script&lang=js"

import "./HeroComp.vue?vue&type=style&index=0&id=9d3e54f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d3e54f4"]])

export default __exports__